import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Dialog } from "@mui/material";
import { Box } from "@mui/system";
import CloseButton from "~/components/_uikit/CloseButton/CloseButton";
import useIsMobileView from "~/hooks/useIsMobile";

import s from "./BaseModal.module.scss";

interface Props {
  isOpened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  textConfirm?: string;
  textClose?: string;
  width?: number | string;
  hideCloseButton?: boolean;
  maxButtonWidth?: string; // px
  centered?: boolean;
  isFullscreenOnMobile?: boolean;
  children?: React.ReactNode;
}

export const BaseModal: React.FC<Props> = observer(
  ({
    isOpened = false,
    width = "510px",
    children,
    onConfirm,
    onClose,
    textClose = "Отменить",
    textConfirm = "Подтвердить",
    hideCloseButton = false,
    isFullscreenOnMobile = false,
  }) => {
    const style = {
      width: "100%",
      maxWidth: width,
      bgcolor: "white",
      borderRadius: "10px",
      px: 0,
      py: 0,
    };

    const { isMobileView } = useIsMobileView();

    const modalMobileStyles = {
      ...(isFullscreenOnMobile &&
        isMobileView && {
          width: "100%",
          maxHeight: "100%",
          height: "100%",
          margin: "0px",
        }),
      ...(isFullscreenOnMobile && !isMobileView && { width: "100%" }),
    };

    const [open, setOpen] = useState(isOpened);

    useEffect(() => {
      setOpen(isOpened);
    }, [isOpened]);

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        className={s.modal}
        PaperProps={{
          sx: {
            "&.MuiPaper-root": {
              overflowY: "unset",
              boxShadow: "none",
              ...modalMobileStyles,
            },
          },
        }}
      >
        <div className={s.modalWrapper}>
          <Box sx={style}>
            {!hideCloseButton && <CloseButton onClose={handleClose} />}

            {children}

            {(textClose || textConfirm) && (
              <div
                className={`${s.modalOptions} ${
                  textClose && textConfirm
                    ? s.modalOptionsTwoBtn
                    : s.modalOptionsOneBtn
                }`}
              >
                {textClose && (
                  <button
                    className="button button--outlined"
                    onClick={handleClose}
                  >
                    {textClose}
                  </button>
                )}
                {textConfirm && (
                  <button className="button" onClick={onConfirm}>
                    {textConfirm}
                  </button>
                )}
              </div>
            )}
          </Box>
        </div>
      </Dialog>
    );
  }
);

BaseModal.displayName = "BaseModal";

export default BaseModal;
